import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a780c098295d50014927678_1786451587344_01ab8628/visitorgate/src/app/raw-materials/components/RawMaterialsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a780c098295d50014927678_1786451587344_01ab8628/visitorgate/src/components/Sidebar.tsx");
